import React, { useState, useContext, useEffect } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonItemDivider, IonGrid, IonItem, IonCol, IonList, IonRow, IonButton, IonModal, IonMenuButton, IonDatetime, useIonViewWillEnter } from '@ionic/react'
import db from '../../resources/db'
import moment from "moment";
import { menuController } from '@ionic/core'
import { ConfigContext } from '../../contexts/ConfigContext'
import AddCustomer from './AddCustomer';
import BalanceReport from '../Report/BalanceReport';
import { APPLINKS } from '../../resources/AppConst';

const Ledger = () => {

  const { getLedgerValues } = useContext(ConfigContext)
  const [TodaysLedger, setTodaysLedger] = useState([]);
  const [ModelOpen, setModelOpen] = useState(false)
  const [LedgerVals, setLedgerVals] = useState({
    payable: 0,
    receivable: 0,
    cashinHand: 0,
    balance: 0,
    credit: 0,
    debit: 0,
  });

  const { payable, receivable, credit, debit, balance } = LedgerVals;

  useEffect(() => {
    getLedgerValues().then(res => {
      setLedgerVals(res)
    });

    getLedgerbyDate().then(res => {
        setTodaysLedger(res);
      });

    return () => {
      setTodaysLedger([]);
      setLedgerVals({});
    }
  }, [getLedgerValues])


  useIonViewWillEnter(() => {
    menuController.enable(true, 'LedgerMenu')
  })

  const [date, setDate] = useState(Date())

  const ledgerChange = async e => {
    setDate(e.target.value)
    let billdate = moment(e.target.value).format("ll")
    getLedgerbyDate(billdate).then(res => {
      setTodaysLedger(res);
    });

  }

  const TodayslederTable = TodaysLedger.length ? (
    TodaysLedger.map(item => {
      return (
        <IonItem key={item.id} routerLink={`${APPLINKS.ledger}/${btoa(item.customerName)}`} >
          <IonCol size='5'>{item.customerName} </IonCol>
          <IonCol>&#8377; {(item.debit).toFixed(2)}</IonCol>
          <IonCol>&#8377; {(item.credit).toFixed(2)}</IonCol>

        </IonItem>
      );
    })
  ) : ('');

  return (
    <IonPage id='ledger'>
      <IonHeader>
        <IonToolbar>

          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>

          <IonTitle>Ledger</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className='ion-padding'>
        <IonRow>
          <IonCol>
            <h6 className="">Total Debit : &#8377; {(debit?.toFixed(2))}</h6>
            <h6 className="">Total Credit : &#8377; {credit?.toFixed(2)}</h6>
            <h5 className="">Total Balance : &#8377; {balance?.toFixed(2)}</h5>
            <h5 className="">Total Receivables : &#8377; {receivable?.toFixed(2)}</h5>
            <h5 className="">Total Payables : &#8377; {payable?.toFixed(2)}</h5>
          </IonCol>
          <IonCol offset='5'>
            <IonButton color='danger' onClick={() => setModelOpen(true)}>Add Customer</IonButton>
            <IonModal isOpen={ModelOpen} cssClass='addCustomer' onDidDismiss={() => setModelOpen(false)} >
              <AddCustomer setModelOpen={setModelOpen} />
            </IonModal>
            <BalanceReport />
          </IonCol>
        </IonRow>
        <IonItemDivider />
        <IonRow class='ion-justify-content-center'>
          <IonCol class='ion-align-self-center' sizeMd='auto'>
            <h4>Ledger -  </h4>
          </IonCol>
          <IonCol class='ion-align-self-center' sizeMd='auto'>
            <h4><IonDatetime id='date' value={date} onIonChange={ledgerChange}></IonDatetime></h4>
          </IonCol>
        </IonRow>
        {
          TodayslederTable.length ? (
            <IonGrid>
              <IonRow class='ion-justify-content-center'>
                <IonCol class='ion-align-self-center' sizeMd='9' >
                  <IonList>
                    <IonItem color='medium'>
                      <IonCol size='5' className="">Name</IonCol>
                      <IonCol className="center-align">Debit</IonCol>
                      <IonCol className="center-align">Credit</IonCol>
                    </IonItem>
                    {TodayslederTable}
                  </IonList>
                </IonCol>
              </IonRow>
            </IonGrid>) : ('')
        }
      </IonContent>
    </IonPage>

  )
}

export default Ledger

export async function getLedgerbyDate(date = moment().format("ll")) {
  let ledger = await db.ledger.where("date").equals(date).reverse().toArray();
  return ledger;
}
